import React from "react";
import styles from "./BackToSearchResultButton.scss";
import cx from "../../utils/cx";
import { IProperty } from '../../utils/JsonApiRequest';
import Icon from '../MaterialUi/Icon';
import Config from '../../utils/Config';

export interface IBackToSearchResultButtonProps {
    className?: string;
    id: IProperty['drupal_internal__id'];
}

const baseUrl = Config.get('baseUrl');

const isSearchResultPage = (url: string) => {
    return url.includes(baseUrl) && (url.includes('/immobilien') || url.includes('/suche'));
};

const BackToSearchResultButton: React.FC<React.PropsWithChildren<IBackToSearchResultButtonProps>> = ({ className = '', id }) => {
    const cleanedReferrer = document.referrer.replace(/[&?]active=\d+/g, ''); // strip old active=123 query params
    const refererWithActiveHome = cleanedReferrer + (cleanedReferrer.includes('?') ? '&' : '?') + `active=${id}`;

    return isSearchResultPage(document.referrer) ? (
        <a href={refererWithActiveHome} className={cx(styles.backToSearchResultButton, className)}>
            <Icon name="backArrow" /> Zurück zur Suche
        </a>
    ) : (
        <div className={cx(styles.backToSearchResultButton, className)}>&nbsp;</div>
    );
};

export default BackToSearchResultButton;
